export type Card = {
  id?: number;
  name: string;
  type: string;
  data: string;
  status?: boolean;
  createdAt: string;
  updatedAt: string;
};

export enum CardType {
  GENERIC = "generic",
  IMAGE = "image",
  VIDEO = "video",
  AUDIO = "audio",
  FILE = "file",
  LIVECHAT = "livechat",
  BUTTON = "button",
}

export const cardTypeMap: Record<CardType, string> = {
  [CardType.GENERIC]: "Generic",
  [CardType.IMAGE]: "Image",
  [CardType.VIDEO]: "Video",
  [CardType.AUDIO]: "Audio",
  [CardType.FILE]: "File",
  [CardType.LIVECHAT]: "Live Chat",
  [CardType.BUTTON]: "Button",
};
